import React from "react";
import { OverlayTrigger } from "react-bootstrap";

import styles from "./sidebarTooltip.module.scss";

const SidebarTooltip = ({ text, placement, children }) => {
	return (
		<OverlayTrigger
			placement={placement}
			overlay={props => (
				<span
					style={props.style}
					ref={props.ref}
					show={props.show.toString()}
					className={styles.tooltip}
				>
					<span className={styles.arrowLeft} />
					<span className={styles.textContainer}>
						<strong className={styles.text}>{text}</strong>
					</span>
				</span>
			)}
		>
			{children}
		</OverlayTrigger>
	);
};

export default SidebarTooltip;
